
/* styles */
require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../vue-loader/lib/style-rewriter?id=data-v-0b1ceebe!stylus-loader?sourceMap!../../../../vue-loader/lib/selector?type=styles&index=0!./Hue.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./Hue.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler?id=data-v-0b1ceebe!../../../../vue-loader/lib/selector?type=template&index=0!./Hue.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-color/src/components/common/Hue.vue
// module id = 297
// module chunks = 1